import {Column} from 'react-table'
import {ParameterName} from './ParameterName'
import {ParameterActionsCell} from './ParameterActionsCell'
import {ParameterCustomHeader} from './ParameterCustomHeader'
import {Parameter} from '../../core/_models'

const ParameterColumns: ReadonlyArray<Column<Parameter>> = [
  {
    Header: (props) => (
      <ParameterCustomHeader
        tableProps={props}
        title='COMMON.INPUT_NAME'
        className='min-w-auto text-center flex-row-fluid flex-center'
      />
    ),
    id: 'name',
    Cell: ({...props}) => <ParameterName measurement_units={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <ParameterCustomHeader
        tableProps={props}
        title='MENU.ACTIONS'
        className='min-w-auto text-center flex-row-fluid flex-center'
      />
    ),
    id: 'actions',
    Cell: ({...props}) => <ParameterActionsCell data={props.data[props.row.index]} />,
  },
]

export {ParameterColumns}
